import React from 'react';

import { Box, Tabs } from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';

import { isMobileView } from 'constants/isMobileView';

import { PageHeading } from 'uiToolkitV1/Headings';
import { Tab, TabList } from 'uiToolkitV1/Tabs';

const PageTabbedNavigation = ({ tabsData, selectedTabName, title, cohortName }) => {
  const filteredTabsData = cohortName === 'My Initiatives' ? tabsData.slice(0, 1) : tabsData;
  const tabIndex = filteredTabsData.findIndex((tabData) => tabData.name === selectedTabName);
  const allowedSettingsTabs = filteredTabsData.filter(({ accessFn }) => accessFn());
  const history = useHistory();

  const onTabChangeHandler = (index) => {
    history.push({
      pathname: allowedSettingsTabs?.[index].route,
      search: allowedSettingsTabs?.[index].search,
    });
  };

  return (
    <Box bg="neutral.F5F7F9" boxShadow="0px 1px 4px #cfd7df;">
      <PageHeading title={title} />
      {!isMobileView() && (
        <Tabs isLazy index={tabIndex} onChange={onTabChangeHandler}>
          <TabList>
            {allowedSettingsTabs.map(({ name }) => (
              <Tab key={name}>{name}</Tab>
            ))}
          </TabList>
        </Tabs>
      )}
    </Box>
  );
};

export { PageTabbedNavigation };
